<template>
  <div class="org-statistics">
    <el-row class="all">
      <div v-for="item in statisticsAllColumns" :key="item.prop">
        <div>{{statisticsAll[item.prop] || 0}}</div>
        <div>{{item.label}}</div>
      </div>
    </el-row>

    <el-row class="search-row">
      <el-input placeholder="输入企业名称搜索" v-model="params.orgName" @change="searchData" clearable></el-input>
      <el-button type="primary" @click="searchData" icon="search">搜索</el-button>
    </el-row>

    <el-table :data="statisticsOrgs" tooltip-effect="dark" border stripe height="calc(100vh - 335px)"
      row-key="id" default-expand-all v-loading="loading">
      <el-table-column v-for="(column, index) in statisticsOrgsColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>

      <el-table-column label="操作" width="120" fixed="right">
        <template #="{row}">
          <el-button type="text" @click="toInfo(row.id)">进入企业</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
      @size-change="lengthChange">
    </el-pagination>
  </div>
</template>

<script>
import { getAllOrgStatistics, getStatisticsByOrg } from '@/api/sys/org';
import { defineComponent } from 'vue'

export default defineComponent({
  data() {
    return {
      statisticsAll: {},
      statisticsAllColumns: [
        { prop: 'orgNum', label: '企业总数' },
        { prop: 'projectNum', label: '项目总数' },
        { prop: 'projectCompletedNum', label: '已完工项目' },
        { prop: 'projectUncompletedNum', label: '未完工项目' },
        { prop: 'userNum', label: '项目总人数' }
      ],
      loading: false,
      total: 0,
      statisticsOrgs: [],
      statisticsOrgsColumns: [
        { type: 'index', label: '序号', width: 85 },
        { prop: 'fullName', label: '企业名称' },
        { prop: 'projectNum', label: '项目总数' },
        { prop: 'projectCompletedNum', label: '已完工项目' },
        { prop: 'projectUncompletedNum', label: '未完工项目' },
        { prop: 'userNum', label: '项目总人数' }
      ],
      params: {
        orgName: null,
        pageNo: 1,
        length: 20
      }
    };
  },
  methods: {
    getStatisticsAll() {
      getAllOrgStatistics().then(({data}) => {
        this.statisticsAll = data.data || {}
      });
    },
    getOrgStatistics() {
      this.loading = true;
      getStatisticsByOrg(this.params).then(({data}) => {
        this.statisticsOrgs = data.data;
        this.total = data.page.totalRecords;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    searchData() {
      this.params.pageNo = 1;
      this.getOrgStatistics();
    },
    pageNoChange(pageNo) {
      this.params.pageNo = pageNo;
      this.getOrgStatistics();
    },
    lengthChange(length) {
      this.params.length = length;
      this.searchData();
    },
    toInfo(orgId) {
      this.$router.push(`/sys/org/info?id=${orgId}`)
    }
  },
  mounted() {
    this.getStatisticsAll();
    this.getOrgStatistics();
  }
})
</script>

<style lang="scss" scoped>
.org-statistics {
  padding: 20px;
  .all {
    >div {
      background-color: #409eff;
      color: #fff;
      text-align: center;
      width: calc(20% - 1px);
      >div {
        padding: 8px 0;
        & + div {
          font-size: 1.1em;
        }
      }
      & + div {
        border-left: 1px solid #fff;
      }
    }
  }
  .search-row {
    margin: 25px 0;
    .el-input {
      width: 250px;
      margin-right: 25px;
    }
  }
  .el-table {
    margin-bottom: 25px;
  }
}
</style>
